import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { RecommendationCopyKeys, createRecommendationCopy } from '../copy';

import { deleteProgrammeRecommendation } from '@api';
import { CurriculumQueryKeys } from '@services';

export const useDeleteProgrammeRecommendation = (
    recommendationId: number | undefined,
    onSuccessCallback?: () => void,
) => {
    const queryClient = useQueryClient();

    const { mutate: deleteRecommendation, isPending: isDeleting } = useMutation(
        {
            mutationFn: () => deleteProgrammeRecommendation(recommendationId),
            onSuccess: () => {
                enqueueSnackbar(
                    createRecommendationCopy(
                        RecommendationCopyKeys.DELETE_SUCCESS,
                    ),
                    {
                        key: 'delete-recommendation-success',
                        testId: 'delete-recommendation-success',
                        variant: 'curriculumSnackbar',
                        severity: 'success',
                    },
                );

                queryClient.invalidateQueries({
                    queryKey: [CurriculumQueryKeys.PROGRAMME_RECOMMENDATIONS],
                });

                onSuccessCallback?.();
            },
            onError: (error: Error) => {
                enqueueSnackbar(error.message, {
                    title: createRecommendationCopy(
                        RecommendationCopyKeys.DELETE_ERROR,
                    ),
                    key: 'delete-recommendation-error',
                    testId: 'delete-recommendation-error',
                    variant: 'curriculumSnackbar',
                    severity: 'error',
                });
            },
        },
    );

    return { deleteRecommendation, isDeleting };
};
